'use client';

import { HeroSectionColumn as KeziosHeroSection } from '@kezios/design-system';

import { FeatureHeroCta } from './FeatureHeroCta/FeatureHeroCta';
import { FeatureHeroDecoration } from './FeatureHeroDecoration/FeatureHeroDecoration';

export type FeatureHeroSectionProps = {
  title: string;
  subtitle: string;
  demoUrl?: string;
  demoTitle?: string;
  videoComponent: (...props: any) => JSX.Element;
  compatibilities: React.ReactNode[];
  currentLocale: string;
};

export const FeatureHeroSection = ({
  title,
  subtitle,
  demoUrl,
  demoTitle,
  videoComponent,
  compatibilities,
  currentLocale,
}: FeatureHeroSectionProps) => {
  return (
    <KeziosHeroSection
      title={title}
      subtitle={subtitle}
      cta={
        <FeatureHeroCta
          demoUrl={demoUrl}
          demoTitle={demoTitle}
          currentLocale={currentLocale}
        />
      }
      decoration={
        <FeatureHeroDecoration
          videoComponent={videoComponent}
          compatibilities={compatibilities}
        />
      }
    />
  );
};
